/* eslint-disable react-native/no-raw-text */
import React from 'react';
import { COLORS,FONTS } from '@bcm/constants';
import { View, Text, StyleSheet, Image } from 'react-native';
import { Parallax } from 'react-parallax';
import { useSelector } from 'react-redux';

const Product = () => {

	const isLandscape = useSelector( state => state.globals.isLandscape);

	const styles = StyleSheet.create({
		container: {
			height: isLandscape ? '80vh' : undefined,
			minHeight: isLandscape ? 700 : undefined,
			width: '100%',
			flexDirection: isLandscape ? 'row' : 'column',
			justifyContent: 'center',
		},
		column1: {
			flex: 1,
			justifyContent: 'center',
			alignItems: 'center',
		},
		column2: {
			flex: 2,
			justifyContent: 'center',
			alignItems: 'center',
		},
		imageContainer: {
			height: 600,
			width: 300,
			marginVertical: isLandscape ? undefined : 25,
		},
		textContainer: {
			height: isLandscape ? '40vh' : undefined,
			minHeight: isLandscape ? 400 : undefined,
			padding: 10,
			borderRadius: 10,
			marginHorizontal: isLandscape ? 50 : 10,
			marginVertical: isLandscape ? undefined : 25,
			backgroundColor: COLORS.white,
			justifyContent: 'space-evenly',
			opacity: 0.9,
		},
		text: {
			fontFamily: FONTS.default,
			fontSize: 30,
			marginVertical: 10
		},
		highlightText: {
			fontFamily: FONTS.default,
			color: COLORS.primary,
		},
	});

	return (
		<Parallax
			blur={5}
			bgImage={require('../../assets/images/doctorTablet.jpg')}
			bgImageAlt="Doctor Product Page"
			strength={isLandscape ? 400 : 100}
		>
			<View style={styles.container}>
				<View style={styles.column2}>
					<View style={styles.textContainer}>
						<Text style={styles.text}>
							{'\u2022 Have a '}
							<Text style={styles.highlightText}>{'second opinion'}</Text>
							{' in your pocket'}
						</Text>
						<Text style={styles.text}>
							{'\u2022 Spend '}
							<Text style={styles.highlightText}>{'time with patients,'}</Text>
							{' not the EHR'}
						</Text>
						<Text style={styles.text}>
							{'\u2022 Keep connected with '}
							<Text style={styles.highlightText}>{'telemedicine'}</Text>
						</Text>
						<Text style={styles.text}>
							{'\u2022'}
							<Text style={styles.highlightText}>{' BurnCam supports you,'}</Text>
							{' along every step'}
						</Text>
					</View>
				</View>
				<View style={styles.column1}>
					<Image
						source={require('../../assets/images/screens/EOCs.PNG')}
						style={styles.imageContainer}
						resizeMethod={'contain'}
					/>
				</View>
			</View>
		</Parallax>
	);
};

export default Product;